import React from 'react'
import { observer } from 'mobx-react-lite'

import { Box, CircularProgress } from '@material-ui/core'

import { MyTable } from './MyTable'

import { useOzonAccount } from '../hooks/routeHooks'
import { useLogic, useStore } from '../hooks/storeHook'
import { useBoolState, useLazyEffect } from '../hooks/commonHooks'
import { useSettingsPageStyles } from '../hooks/settingsPageStylesHook'

import { ozonFilesColumns } from '../types/ozonFilesColumns'

export const OzonFilesTab =
  observer(() => {
    const account = useOzonAccount()

    const {labelStore: {ozonFiles}} = useStore()
    const {loadOzonFiles} = useLogic()
    const classes = useSettingsPageStyles()

    const [isLoading, /*setLoading*/, setLoaded] = useBoolState(true)

    useLazyEffect(() => loadOzonFiles(account.id).finally(setLoaded))

    return (
      <Box className={classes.fullWidth}>
        {
          isLoading
          ? <CircularProgress size={30}/>
          :
          <MyTable
            table={ozonFiles}
            columns={ozonFilesColumns}
            labelNoRows={'Файлов нет'}
            labelNotFound={'Файлы не найдены'}
            labelRowsPerPage={'Файлов на странице:'}
          />
        }

        {
          ozonFiles.totalRowCount >= 500 &&
          <small>
            Показаны последние 500 файлов.
          </small>
        }
      </Box>
    )
  })